export default __webpack_public_path__ + "static/media/poor-portfolio.54aa1d8d.png";